<template>
  <Layout class="layout_simple">
    <template v-slot:main>
      <div class="section section_flex-center">
        <Loader/>
      </div>
    </template>
  </Layout>
</template>

<script>

import {VIEWS} from '@/views/names'
import {mapActions} from 'vuex'
import * as types from '@/store/types'
import StatusRequest from '@/app/model/status/status-request'

import Loader from '@/app/components/Loader'
import Layout from '@/app/components/Layout'

export default {
  name: VIEWS.init.name,
  components: {
    Layout,
    Loader
  },
  methods: {
    ...mapActions({
      guiTryInitSet: types.GUI.tryInit.set,
      setStatusRequest: types.APP.statusRequest.set
    }),
    getRouteData () {
      try {
        const statusRequest = new StatusRequest({
          pointId: this.$route?.query?.p,
          saleId: this.$route?.query?.d,
          saleCode: this.$route?.query?.a
        })
        this.setStatusRequest({statusRequest})
      } catch (e) {
        this.$pageManager.showError({
          title: 'Ошибка',
          desc: 'Ссылка не действительна'
        })
      }
    }
  },
  mounted() {
    this.guiTryInitSet()
    this.getRouteData()
    this.$service.statusReceipt()
  }
}
</script>
